import React, { Component } from "react";
import { Spinner } from "office-ui-fabric-react";
import Unauthorized from "./Unauthorized";
import { getUserByToken } from "../../services/apiClient";
import { getUserLogged, setUserLogged } from "../../services/loginClient";

export default class Protected extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            adUser: props.user
        };
    }

    async componentDidMount() {
        const { user } = this.props;

        if (user == null) {
            if (window.location.pathname.includes("auto-login")) {
                const authToken = findGetParameter("code");
                const adUser = await getUserByToken(authToken);

                if ('token' in adUser) {
                    setUserLogged(adUser);
                }

                window.location.href = "/";

                this.setState({ isLoading: false, adUser });
            }
            else {
                const baseServer = `${window.location.protocol}//${window.location.hostname
                    }${window.location.port !== "" ? ":" + window.location.port : ""}`;

                window.location.href = `/api/login?customReturnUrl=${baseServer}/api/auto-login`;
            }
        }
        else {
            this.setState({ isLoading: false, adUser: user });
        }
    }

    render() {
        const { isLoading, adUser } = this.state;

        //Check is autorized
        const authorized = calculateAuthorized(adUser);

        if (isLoading) {
            return <Spinner />;
        }
        else {
            if (authorized) {
                return this.props.children;
            } else {
                return <Unauthorized />;
            }
        }
    }
}

function calculateAuthorized(adUser) {
    let result = true;

    result = result && adUser != null;

    return result;
}

function findGetParameter(parameterName) {
    var result = null, tmp = [];

    window.location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });

    return result;
}